<!--
  Modify error — sub-modale modifica errore registrato su un ordine.
  Redesigned 2026-06-15 (v2.9.0, Phase 1.5 Chunk H.4).

  Drops kendo-dialog + 3× kendo-formfield + 3× kendo-label +
  kendoTextBox + 2× kendo-combobox + 2× kendo-formerror + ~12 inline
  styles (12 kendo refs → 0).

  Pattern modale Diakonix MD (sub-sub-modale, z-index 2200 sopra il
  modale errori H.3 che è 2100, sopra storico-ordini-dettagli H.2
  che è 2000).

  Bug fix: il legacy chiamava `window.location.reload()` in setError
  sia success che error branches → hard page reset. Ora `modalClosed1`
  event al parent fa ricaricare solo la lista errori.
-->

<div class="modal-backdrop modal-backdrop--xl-nest" (click)="close()">
  <div
    class="modal modal--md"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modify-error-title"
    (click)="$event.stopPropagation()"
  >

    <!-- ─── Header ────────────────────────────────────────────── -->
    <header class="modal__header">
      <h2 id="modify-error-title" class="modal__title">
        <span aria-hidden="true">✏️</span>
        Modifica errore
      </h2>
      <button
        type="button"
        class="modal-close"
        (click)="close()"
        aria-label="Chiudi"
      >×</button>
    </header>

    <!-- ─── Body ──────────────────────────────────────────────── -->
    <div class="modal__body">
      <form
        class="form-grid"
        [formGroup]="errorForm"
        (ngSubmit)="setError()"
      >
        <!-- Descrizione -->
        <label class="field field--full">
          <span class="field__label">
            Descrizione <span class="field__required" aria-hidden="true">*</span>
          </span>
          <textarea
            class="field__input field__input--textarea"
            formControlName="oe_description"
            rows="3"
            placeholder="Descrizione dell'errore…"
            maxlength="500"
            [class.field__input--invalid]="
              errorForm.get('oe_description')?.touched &&
              errorForm.get('oe_description')?.invalid
            "
          ></textarea>
          @if (
            errorForm.get('oe_description')?.touched &&
            errorForm.get('oe_description')?.invalid
          ) {
            <span class="field__error">Descrizione obbligatoria</span>
          }
        </label>

        <!-- Gravità (1-10) -->
        <label class="field">
          <span class="field__label">
            Gravità <span class="field__required" aria-hidden="true">*</span>
          </span>
          <select
            class="field__input"
            formControlName="oe_error_gravity"
            [class.field__input--invalid]="
              errorForm.get('oe_error_gravity')?.touched &&
              errorForm.get('oe_error_gravity')?.invalid
            "
          >
            <option [ngValue]="''">— seleziona valore —</option>
            @for (v of values; track v) {
              <option [ngValue]="v">{{ v }}</option>
            }
          </select>
          @if (
            errorForm.get('oe_error_gravity')?.touched &&
            errorForm.get('oe_error_gravity')?.invalid
          ) {
            <span class="field__error">Gravità obbligatoria</span>
          }
        </label>

        <!-- Tipo errore -->
        <label class="field">
          <span class="field__label">
            Tipo <span class="field__required" aria-hidden="true">*</span>
          </span>
          <select
            class="field__input"
            formControlName="oe_error_type_id"
            [class.field__input--invalid]="
              errorForm.get('oe_error_type_id')?.touched &&
              errorForm.get('oe_error_type_id')?.invalid
            "
          >
            <option [ngValue]="''">— seleziona tipo —</option>
            @for (t of errorTypes; track t.error_type_code) {
              <option [ngValue]="t.error_type_code">{{ t.error_type_desc }}</option>
            }
          </select>
          @if (
            errorForm.get('oe_error_type_id')?.touched &&
            errorForm.get('oe_error_type_id')?.invalid
          ) {
            <span class="field__error">Tipo obbligatorio</span>
          }
        </label>
      </form>
    </div>

    <!-- ─── Footer ────────────────────────────────────────────── -->
    <footer class="modal__footer">
      <button
        type="button"
        class="btn btn--ghost"
        (click)="close()"
        [disabled]="saving"
      >Annulla</button>

      <button
        type="button"
        class="btn btn--primary"
        (click)="setError()"
        [disabled]="errorForm.invalid || saving"
      >
        @if (saving) {
          <span class="btn__spinner" aria-hidden="true"></span>
          Salvataggio…
        } @else {
          <span aria-hidden="true">💾</span>
          Salva
        }
      </button>
    </footer>
  </div>
</div>
